import { AiLanguage, PeriodType } from "~/graphql";

import { type Integration } from "~/stores/integrationStore";

const backendEndpointPlaceholder = 'https://api.app.teachino.io'; // this string will be replaced during production build
let backendEndpoint = backendEndpointPlaceholder;
if (backendEndpoint.indexOf('http') === -1) {
  // if endpoint is not replaced during build: fallback to default
  backendEndpoint = 'http://localhost:3000';
  //backendEndpoint = 'https://api.ifinger.edudev.at';
  //backendEndpoint = 'https://api.penegal.edudev.at';
  //backendEndpoint = 'https://api.seceda.edudev.at';
  //backendEndpoint = 'https://api.app.teachino.io';
}

export const apiUrl = backendEndpoint;

const iframeBaseURLPlaceholder = 'https://embed.teachino.online'; // this string will be replaced during production build;
let iframeBaseURL = iframeBaseURLPlaceholder;
if (iframeBaseURL.indexOf('http') === -1) {
  iframeBaseURL = 'http://localhost:3000';
  //iframeBaseURL = 'https://api.ifinger.edudev.at';
}

const mpEndpointPlaceholder = 'https://mpp.app.teachino.io/';
const mpKeyPlaceholder = '680904b37bf79e82cef99693ebe3cc5e';
const mpActivePlaceholder = 'true';
export let mpEndpoint = mpEndpointPlaceholder;
export let mpKey = mpKeyPlaceholder;
let mpActiveString = mpActivePlaceholder;
export let mpActive = true;
if (mpEndpointPlaceholder === 'https://mpp.app.teachino.io/') {
  mpEndpoint = 'https://mpp.edudev.at';
}
if (mpKey === '680904b37bf79e82cef99693ebe3cc5e') {
  mpKey = '564a3612134a8ca4cd7cf30a99cbf50b';
}
if (mpActiveString === 'true') {
  mpActiveString = 'true';
}
if (mpActiveString != 'true') {
  mpActive = false;
}
if (window.location.hostname === 'app.teachino.io') {
  mpKey = '680904b37bf79e82cef99693ebe3cc5e';
  mpEndpoint = 'https://mpp.app.teachino.io';
}

export const iframeEmbedBaseUrl = iframeBaseURL + '/embed-snippet/';

export const imageStorageUrl =
  'https://storage.de.cloud.ovh.net/v1/AUTH_97856089b0cd40beace6493b15fd316e/teachinomedia/images/';

export const pictureUrls = {
  login_background: imageStorageUrl + 'signup/login_alex.jpg',
  circle_background: imageStorageUrl + 'circle_bg.png',
  error: imageStorageUrl + 'error.jpg',
  timetable_empty: imageStorageUrl + 'timetable_empty.png',
  course_empty: imageStorageUrl + 'course_empty.png',
};

export const videoStorageUrl =
  'https://storage.de.cloud.ovh.net/v1/AUTH_97856089b0cd40beace6493b15fd316e/teachinomedia/video/';
export const videoUrls = {
  onboarding_period: videoStorageUrl + 'de_onboarding_period.mp4',
  onboarding_course_content:
    videoStorageUrl + 'de_onboarding_course_content.mp4',
};

export const tutorialRoute =
  '/c/01gjgf3pgndhnme33jay3na7kt/course/01GJ23BSDX51B1RV56SXSM37ZJ';

export const helpUrl = 'https://www.teachino.io/hilfe';
export const meetingUrl = 'https://www.teachino.io/termin';

export const upsellUrl = 'https://www.teachino.io/in-app-schullizenz';
export const luxembourgIamAuthUrl = backendEndpoint + '/cgie/saml/login';

export const aiLanguages = [
  {
    id: AiLanguage.De,
    label: 'Deutsch',
  },
  {
    id: AiLanguage.En,
    label: 'Englisch / English',
  },
  {
    id: AiLanguage.It,
    label: 'Italienisch / Italiano',
  },
  {
    id: AiLanguage.Es,
    label: 'Spanisch / Español',
  },
  {
    id: AiLanguage.Fr,
    label: 'Französisch / Français',
  },
  {
    id: AiLanguage.Pt,
    label: 'Portugiesisch / Português',
  },
  {
    id: AiLanguage.Tr,
    label: 'Türkisch / Türkçe',
  },
  {
    id: AiLanguage.Po,
    label: 'Polnisch / Polski',
  },
  {
    id: AiLanguage.Nl,
    label: 'Niederländisch / Nederlands',
  },
  {
    id: AiLanguage.Se,
    label: 'Schwedisch / Svenska',
  },
  {
    id: AiLanguage.Ru,
    label: 'Russisch / Русский',
  },
  {
    id: AiLanguage.Sl,
    label: 'Slovenisch / Slovenščina',
  },
  {
    id: AiLanguage.Cs,
    label: 'Tschechisch / Čeština',
  },
  {
    id: AiLanguage.Lb,
    label: 'Luxemburgisch / Luxembourgish',
  },
];

export const timetableSettings = {
  firstHour: 7,
  lastHour: 22,
};

// vue draggable specific definitions
export const DraggableActions = {
  added: 'added',
  removed: 'removed',
  move: 'moved',
};

export enum DraggableActionsEnum {
  added = 'added',
  removed = 'removed',
  moved = 'moved',
}

export type DraggableActionsUnion = keyof typeof DraggableActionsEnum;

export type IDraggableEvent = {
  [key in DraggableActionsEnum]: {
    newIndex?: number;
    oldindex?: number;
    [key: string]: any;
  };
};

export const draggableActionWrapper = (
  draggableEvent: IDraggableEvent,
  actions: { [key in DraggableActionsEnum]?: () => void },
) => {
  const actionName = Object.keys(draggableEvent)[0] as DraggableActionsUnion;
  // if action is available, execute
  if (actions[actionName]) {
    const selectedMethod = actions[actionName] as () => void;
    selectedMethod();
  }
};

export function urlForCourseInvite(code: string): string {
  return (
    window.location.protocol + '//' + window.location.host + '/invite/' + code
  );
}

export function urlForPublicCourse(code: string): string {
  return window.location.protocol + '//' + window.location.host + '/c/' + code;
}

export function urlForRoute(route: string): string {
  return window.location.protocol + '//' + window.location.host + route;
}

export const COURSE_NAME_CHAR_LIMIT = 50;

export const SHORT_NAME_CHAR_LIMIT = 6;

export const MOBILE_BREAKPOINT_SM = 640;

export const ONBOARDING_TRACKING_VERSION = 'V1.0';

export type TimetableData = {
  dayOfWeek: number;
  toTime: string;
  fromTime: string;
};

export enum TimetableStatus {
  regular = 'REGULAR',
  additional = 'ADDITIONAL',
  substitution = 'SUBSTITUTION',
  exam = 'EXAM',
  cancellation = 'CANCELLATION',
  change = 'CHANGE',
  teacher_removed = 'TEACHER_REMOVED',
  vacation = 'VACATION',
  other = 'OTHER',
}

export enum TimetableInputMode {
  grid = 'GRID',
  complex = 'COMPLEX',
}

export type VacationDay = {
  date: string;
  label: string;
};

export type TimetableEvent = {
  id: string;
  title: string;
  titleMobile: string;
  courseId: string;
  foregroundColor: string;
  backgroundColor: string;
  hasNote: boolean;
  descriptionLine1: string;
  descriptionLine2: string;
  allDescriptionLines: string[];
  from: string;
  to: string;
  isFirstInList?: boolean;
  date: string;
  isPlanned: boolean;
  isPast?: boolean;
  isAdditional?: boolean;
  isSubstitution?: boolean;
  courseNotConnected: boolean;
  externalUserCredentialsId?: string;
  source?: string;
  type: PeriodType;
  extensionId?: string;
  timetableEntryId?: string;
  simultaneous?: {
    count: number;
    index: number;
  };
  canDisconnect: boolean;
};

export const AvailableIntegrations: Integration[] = [
  {
    key: 'untis',
    displayName: 'WebUntis',
    emoji: '📅',
    description: 'integration.untis.description',
    iconName: 'untis',
    activationLink: 'https://www.teachino.io/hilfe/integration-mit-web-untis',
    informationOnly: true,
    hasCourses: true,
    hasTimetable: true,
    hasClassRegister: true,
    hasFiles: false,
    isSSOProvider: false,
    canDisconnect: true,
    showOnLoginPage: false,

  },
  {
    key: 'bip',
    displayName: 'Bildungsportal',
    emoji: '🇦🇹',
    description: 'integration.bip.description',
    iconName: 'bip',
    activationLink: backendEndpoint + '/bip/connect',
    informationOnly: false,
    hasCourses: false,
    hasTimetable: false,
    hasClassRegister: false,
    hasFiles: false,
    isSSOProvider: true,
    ssoIconName: 'bip_sso',
    canDisconnect: true,
    showOnLoginPage: true,

  },
  {
    key: 'cgie',
    displayName: 'IAM - Centre de gestion informatique de l\'éducation ',
    emoji: '🇱🇺',
    description: 'integration.cgie.description',
    iconName: 'cgie',
    activationLink: luxembourgIamAuthUrl,
    informationOnly: false,
    hasCourses: false,
    hasTimetable: false,
    hasClassRegister: false,
    hasFiles: false,
    isSSOProvider: true,
    ssoIconName: 'cgie_sso',
    canDisconnect: false,
    showOnLoginPage: true,

  },
  {
    key: 'digreg',
    displayName: 'Digitales Register',
    emoji: '🏔️',
    description: 'integration.digreg.description',
    iconName: 'digreg',
    activationLink:
      'https://www.teachino.io/hilfe/integration-mit-digitales-register',
    informationOnly: true,
    hasCourses: true,
    hasTimetable: true,
    hasClassRegister: true,
    hasFiles: false,
    isSSOProvider: false,
    canDisconnect: true,
    showOnLoginPage: false,
  },
  {
    key: 'microsoft',
    displayName: 'Microsoft Teams, OneDrive und OneNote',
    emoji: '💼',
    description: 'integration.microsoft.description',
    iconName: 'microsoft',
    activationLink: backendEndpoint + '/microsoft/connect',
    informationOnly: false,
    hasCourses: false,
    hasTimetable: false,
    hasClassRegister: false,
    hasFiles: true,
    isSSOProvider: true,
    ssoIconName: 'microsoft_sso',
    canDisconnect: true,
    showOnLoginPage: true,
  },
  {
    key: 'europathek',
    displayName: 'EUROPATHEK',
    emoji: '🇪🇺',
    description: 'integration.europathek.description',
    iconName: 'europathek',
    activationLink: backendEndpoint + '/europathek/connect',
    informationOnly: false,
    hasCourses: false,
    hasTimetable: false,
    hasClassRegister: false,
    hasFiles: false,
    isSSOProvider: true,
    ssoIconName: 'europathek_sso',
    canDisconnect: true,
    showOnLoginPage: false,
  },
];

export const AvailableClassregisterIntegrations = ['untis', 'digreg'];
export const AvailableTimetableIntegrations = ['untis', 'digreg'];
export const AvailableExternalContentIntegrations = ['microsoft'];

export type QuestionType = {
  id: string;
  title: string;
  description: string;
};
export const QuestionTypes: QuestionType[] = [
  {
    id: 'reproduction',
    title: 'item_detail.teachino_ai_questions.reproduction.title',
    description: 'item_detail.teachino_ai_questions.reproduction.description',
  },
  {
    id: 'reorganisation',
    title: 'item_detail.teachino_ai_questions.reorganisation.title',
    description: 'item_detail.teachino_ai_questions.reorganisation.description',
  },
  {
    id: 'reflection',
    title: 'item_detail.teachino_ai_questions.reflection.title',
    description: 'item_detail.teachino_ai_questions.reflection.description',
  },
];

export const acceptedFileTypes = [
  'application/octet-stream',
  'application/pdf',
  'application/PDF',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/rtf',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/x-mspublisher',
  'application/vnd.ms-publisher',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/PNG',
  'image/JPEG',
  'image/JPG',
  'image/GIF',
  'image/bmp',
  'image/BMP',
  'image/tiff',
  'image/TIFF',
  'video/quicktime',
  'audio/mpeg',
  'audio/mp3',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'video/mp4',
  'image/vnd.adobe.photoshop',
  'application/postscript',
  'application/zip',
  'application/vnd.rar',
  'application/vnd.geogebra.file',
  'image/vnd.dwg',
  'application/x-msaccess',
  'application/vnd.apple.pages',
  'application/x-iwork-pages-sffpages',
  'application/vnd.apple.keynote',
  'application/x-iwork-keynote-sffkey',
  'application/vnd.apple.numbers',
  'application/x-iwork-numbers-sffnumbers',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
];

export const acceptedImageTypes = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/PNG',
  'image/JPEG',
  'image/JPG',
  'image/GIF',
];
export const imageTypes = ['png', 'jpg', 'jpeg', 'gif'];

export const PreviewSupportedFileTypes = [
  'pdf',
  'doc',
  'xls',
  'ppt',
  'docx',
  'xlsx',
  'pptx',
  'ppsx',
  'jpg',
  'jpeg',
  'png',
  'tiff',
];

export const PreviewSupportedAudioTypes = ['mp3', 'm4a'];
export const PreviewSupportedVideoTypes = ['mp4'];

export const MaxFileSizeMB = 50;

export const MaxCurriculumLengthHardLimit = 18000;
export const MaxCurriculumLengthSoftLimit = 15000;

export const MaxClassRegisterTextLength = 2000;
export const primaryNoteForegroundColor = '#000000';
